<template>
  <v-btn
    block
    class="text-none font-weight-regular py-1"
    variant="outlined"
    size="large"
    rounded="lg"
    min-height="auto"
    height="auto"
    :loading="getIsLoadingAuthentication && getProvider == 'google'"
    :disabled="
      !isReady ||
      isGooglePopupOpen ||
      getErrorAuthentication != null ||
      !['login', 'invite'].includes(props.action) ||
      (getRegistrationName != null && props.action == 'invite')
    "
    @click.stop="login"
  >
    <div class="d-flex align-center">
      <v-img
        width="30"
        cover
        src="/google_logo.svg"
        alt=""
      />
      <span class="text-wrap text-center ml-3">Continue with {{ getAvailableProviders.google }}</span>
    </div>
  </v-btn>
</template>


<script setup>
import { useCodeClient } from 'vue3-google-signin'
import { storeToRefs } from 'pinia'

import { useAuthentication } from '@/stores/auth'

const authenticationStore = useAuthentication()

const {
  getAvailableProviders,
  getProvider,
  getInviteCode,
  getRegistrationName,
  getIsLoadingAuthentication,
  getErrorAuthentication
} = storeToRefs(authenticationStore)

const {
  login: storeLogin,
  invite: storeInvite,
  setErrorAuthentication,
  setStatusAuthentication,
  nullifyInviteData
} = authenticationStore

const  useGoogleAuth = () => {
  const { isReady, login } = useCodeClient({
    onSuccess: async (response) => {
      if (!Object.hasOwn(response, 'code'))
        setErrorAuthentication('Google authentication failed: no authorization code received.')
      else if (getInviteCode.value == null && props.action == 'invite')
        setErrorAuthentication('Google authentication failed: no invite code available.'  )
      else if (getErrorAuthentication.value == null) {
        if (props.action == 'login')
          await storeLogin('google', response)
        else if (props.action == 'invite')
          await storeInvite(getInviteCode.value,'google', true, response)
      }
      isGooglePopupOpen.value = false
    },
    onError: (error) => {
      if (props.action == 'invite')
        nullifyInviteData()
      setErrorAuthentication(
        error?.response?.data?.response?.error?.message ||
        error.message ||
        String(error) ||
        JSON.stringify(error)
      )
      setStatusAuthentication(error?.status)
      isGooglePopupOpen.value = false
    }
  })
  return { isReady, googleLogin: login }
}
const { isReady, googleLogin } = useGoogleAuth()

const isGooglePopupOpen = ref(false)

const login = () => {
  isGooglePopupOpen.value = true
  googleLogin()
}

const props = defineProps({
  action: {
    type: String,
    required: true
  }
})

onBeforeMount(() => {
  if (!['login', 'invite'].includes(props.action))
    setErrorAuthentication(`Unsupported Google authentication action: ${props.action}`)
})
</script>